document.querySelectorAll('.wp-block-button__link').forEach((el) => {
  if (window._etracker && el.textContent.trim() === 'Jetzt bewerben') {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      _etracker.sendEvent(new et_ClickEvent('JetztBewerbenCTAClick'));
      setTimeout(() => (window.location.href = el.href), 250);
    });
  }
});

document.querySelectorAll('[data-block-name="link-card"]').forEach((el) => {
  if (window._etracker && el.textContent.includes('Stellenangebot')) {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      _etracker.sendEvent(new et_ClickEvent('OrangeLinkCardClick'));
      setTimeout(() => (window.location.href = el.href), 250);
    });
  }
});

document.querySelectorAll('[data-block-name="card"]').forEach((el) => {
  if (window._etracker) {
    const headline = el.querySelector('[data-headline]').textContent.replace(/\n+/g, ' ').trim();

    el.addEventListener('click', (event) => {
      event.preventDefault();
      _etracker.sendEvent(new et_ClickEvent('JobTypeCardClick', headline));
      setTimeout(() => (window.location.href = el.href), 250);
    });
  }
});